import CustomerTypeDropdown from './CustomerTypeDropdown';

export default CustomerTypeDropdown;


// WEBPACK FOOTER //
// ./src/components/CustomerTypeDropdown/index.jsx